module.exports = __webpack_public_path__ + "static/media/reiki.ac667782.jpeg";